import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { visitorClient } from '#pplx_generated/typespec/rest/visitor/client.js';
const DEFAULT_VISITOR_INFORMATION = {
    visitor_queries_past_day: 0,
};
export const getVisitorInformation = async ({ reason, }) => {
    try {
        const { error, data, response } = await visitorClient.GET('/rest/visitor/information', reason, {
            timeoutMs: 1500,
        });
        if (error || !data) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to get visitor information',
                cause: error,
                status: response.status ?? 0,
            });
        }
        return data;
    }
    catch (err) {
        logger.error(err);
        return DEFAULT_VISITOR_INFORMATION;
    }
};
//# sourceMappingURL=getVisitorInformation.js.map